export const root = "rrd7878";
export const minWidth = "m9g2sid";
export const overlayIcons = "op6n2lc";
export const lockIcon = "lspd94p";
export const image = "iplnk5g";
export const lockedImage = "lwvedig";
export const overlay = "ot4pgvt";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");